import { C_Sale_Unit } from '../../../../../../../graphql/generatedModel';

export const heuristicSaleUnitDetection = (raw: string): C_Sale_Unit | undefined => {
  const input = raw.trim();

  if (!input) return undefined;

  const canonical = detectCanonical(input);
  return canonical || detectWeight(clean(input)) || undefined;
};

const clean = (s: string): string => {
  return s
    .trim()
    .replace(/^['"](.*)['"]$/, '$1')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[,;:]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const hasMinusToken = (s: string): boolean => {
  return /\b(minus|neg|moins|meno|-)\b/.test(s) || /\(.*-\s*\)/.test(s);
};

const detectWeight = (s: string): C_Sale_Unit | null => {
  const t = s
    .replace(/\s/g, '')
    .replace(/[,.]/g, '.')
    .replace(/kilograms?|kilogram|kgm?/g, 'kg')
    .replace(/grams?|gr|gms?/g, 'g');

  if (/\b100g\b/.test(t) || /\b0?\.?1kg\b/.test(t) || /\bhg\b/.test(t)) return C_Sale_Unit.SU2_100G;
  if (/\b100\b/.test(s)) return C_Sale_Unit.SU2_100G;

  if (/\b1000g\b/.test(t) || /\b1kg\b/.test(t) || /\bkg\b/.test(t)) return C_Sale_Unit.SU3_1000G;
  if (/\b1000\b/.test(s)) return C_Sale_Unit.SU3_1000G;

  return null;
};

const detectPieceOrCombo = (s: string): C_Sale_Unit | null => {
  const pieceTokens =
    /\b(piece|pieces|pc|pcs|unit|units|stk|st|stueck|stuck|pz|pezzo|pezzi|pce|piece|pi[eè]ce)\b/;
  const weightTokens = /\b(weight|gewicht|poids|peso|g|kg)\b/;
  const andTokens = /\b(and|und|et|e)\b|&|\+/;

  const isPiece = pieceTokens.test(s);

  if (isPiece && (weightTokens.test(s) || andTokens.test(s))) {
    return C_Sale_Unit.SU4_PIECE_AND_WEIGTH;
  }
  if (isPiece) return C_Sale_Unit.SU1_PIECE;
  return null;
};

const detectOpen = (s: string): C_Sale_Unit | null => {
  const openTokens =
    /\b(open|offen|ouvert|ouverte|quantita aperta|importo aperto|montant ouvert|open amount|betrag)\b/;

  if (openTokens.test(s)) {
    return hasMinusToken(s) ? C_Sale_Unit.SU6_OPEN_AMOUNT_MINUS : C_Sale_Unit.SU5_OPEN_AMOUNT;
  }
  return null;
};

const detectCanonical = (raw: string): C_Sale_Unit | null => {
  const s = clean(raw);

  if (/^stk?$/.test(s)) return C_Sale_Unit.SU1_PIECE;
  if (/^pz$/.test(s)) return C_Sale_Unit.SU1_PIECE;
  if (/^pce?$/.test(s)) return C_Sale_Unit.SU1_PIECE;
  if (/^pcs?$/.test(s)) return C_Sale_Unit.SU1_PIECE;

  const w = detectWeight(s);
  if (w) return w;

  const p = detectPieceOrCombo(s);
  if (p) return p;

  const o = detectOpen(s);
  if (o) return o;

  if (hasMinusToken(s)) return C_Sale_Unit.SU6_OPEN_AMOUNT_MINUS;

  return null;
};
